var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',[_c('b-tabs',{attrs:{"pills":"","card":"","vertical":_vm.iswin ? true : false}},[_vm._l((_vm.items),function(item){return _c('b-tab',{attrs:{"title":item.name,"active":""}},[_c('el-card',[_c('div',{domProps:{"innerHTML":_vm._s(item.content)}})])],1)}),_c('b-tab',{attrs:{"title":"研究所活动"}},[_c('Activity')],1)],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }